<template>
  <div class="panel-attention panel-attention-blue">
    <p>
      {{ title }}
      <img
        alt="icon"
        width="1"
        height="1"
        src="https://ad.linksynergy.com/fs-bin/show?id=zQNBiDvaWU0&bids=292260.1&type=10"
      />
    </p>
    <kcs-btn
      :url="url"
      :external="true"
      @click.native="
        handleAnalyticsTrackEvent('facility_detail', 'click', 'ticket_link', 1)
      "
      name="チケットを探す"
    />
  </div>
</template>

<script>
import KcsBtn from '@/components/atoms/kcs-btn.vue'
export default {
  components: {
    KcsBtn
  },
  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  computed: {
    title() {
      return (
        this.detail.name +
        'のイベント・ライブ・コンサート・チケット・前売り券情報'
      )
    },
    url() {
      return (
        'https://click.linksynergy.com/deeplink?id=zQNBiDvaWU0&mid=36672&murl=' +
        this.$options.filters.urlencode(
          'https://md-search.pia.jp/pia/venue/venue.do?venueCd=' +
            this.detail.pia
        )
      )
    }
  }
}
</script>
